import {
    createSlice,
} from '@reduxjs/toolkit'

//const initialPerm = {
//    id: 0,
//    name: 'Unknown',
//    isDriver: false,
//    power: false,
//    adminGpsi: false,
//    admin: false,
//    adminSuper: false,
//}
const initialUser = {
    id: 0,
    name: "Unknown",
    companyid: 0,
    groupid: 0
}
const initialState = {
    accountId: null,
    token: '',
    parent: initialUser,
    parentPerm: null,
    current: initialUser,
    currentPerm: null,
    srchTerm: '',
    colorMode: 'dark',
    vehgroups: [],
    usrgroups: [],
    depotgroups: [],
    remoteCon: null,
}

const userSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {
        setAccountId(state, action) {
            state.accountId = action.payload
        },
        setUser(state, action) {
            let usr = action.payload
            if (!!usr) {
                state.current = usr
                state.currentPerm = usr.perm
                state.usrgroups = action.payload.usrgroups
                state.vehgroups = usr.vehgroups
                state.depotgroups = usr.depotgroups
            } else {
                state.current = initialUser
                state.currentPerm = null
                state.vehgroups = []
                state.depotgroups = []
            }
        },
        setToken(state, action) {
            state.token = action.payload
        },
        setColorMode(state, action) {
            if (!!action.payload) {
                state.colorMode = action.payload
            }
        },
        setSrchTerm(state, action) {
            state.srchTerm = action.payload
        },
        setRemoteCon(state, action) {
            state.remoteCon = action.payload
        },
    },
})

export const { setAccountId, setToken, setUser, setColorMode, setSrchTerm, setRemoteCon } = userSlice.actions
export const accessToken = (state) => state.user.auth.access_token
export const userAccountId = (state) => state.user.accountId
export const userToken = (state) => state.user.token
export const userRemCon = (state) => state.user.remoteCon
export const userColorMode = (state) => state.user.colorMode
export const currentUser = (state) => state.user.current
export const currentPerm = (state) => state.user.currentPerm
export const currentUsrGrps = (state) => state.user.usrgroups
export const currentVehGrps = (state) => state.user.vehgroups
export const currentDepGrps = (state) => state.user.depotgroups
export const userSrchTerm = (state) => state.user.srchTerm

export default userSlice.reducer
